const SECTION_ROUTE_SUFFIX = {
    details: "",
    feedback: "form",
    suggestion: "more",
    share: "share-product",
    contents: "contents",
    market: "menu",
};

export function getFeedbackSectionPath(sectionCode, id) {
    const suffix = SECTION_ROUTE_SUFFIX[sectionCode];
    if (!suffix) {
        return `/feedback/${id}`;
    }
    return `/feedback/${suffix}/${id}`;
}

export function getFeedbackSectionLabel(sections, code, fallback) {
    const section = (sections || []).find((item) => item.code === code);
    if (!section) {
        return fallback;
    }
    const custom = (section.custom_title || "").trim();
    if (custom) {
        return custom;
    }
    const label = (section.label || "").trim();
    return label || fallback;
}

export function resolveDefaultFeedbackSection(ajax) {
    const sections = ajax?.feedback_page_sections;
    const configuredDefault =
        ajax?.feedback_default_section || "feedback";

    const isEnabled = (code) =>
        !sections ||
        sections.find((section) => section.code === code)?.enabled !== false;

    if (isEnabled(configuredDefault)) {
        return configuredDefault;
    }

    const fallbackOrder = [
        "feedback",
        "details",
        "suggestion",
        "share",
        "contents",
        "market",
    ];
    for (const code of fallbackOrder) {
        if (isEnabled(code)) {
            return code;
        }
    }

    return "details";
}
